// extracted by mini-css-extract-plugin
module.exports = {"ActiveTest":"ActiveTest__ActiveTest--3ePh0","Question":"ActiveTest__Question--C8Uq1","question":"ActiveTest__question--3dKfb","Small":"ActiveTest__Small--UeeFV"};